import React from "react";

export default function NotFound404() {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        backgroundColor: "white",
        marginTop: "200px",
        textAlign: "center",
      }}
    >
      <h1>
        Welcome&nbsp;{localStorage.getItem("FName")}&nbsp;
        {localStorage.getItem("LName")}
      </h1>
    </div>
  );
}
